module.exports = __webpack_public_path__ + "img/bg6.9dc9b82e.jpg";